var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditCard(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 19H17.4",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.903 6.50014L16.5708 5.83414C16.8338 5.57123 17.0424 5.2591 17.1848 4.91556C17.3271 4.57203 17.4004 4.20382 17.4004 3.83196C17.4005 3.46011 17.3273 3.09188 17.185 2.74832C17.0427 2.40475 16.8342 2.09257 16.5713 1.82959C16.3084 1.56662 15.9962 1.35801 15.6527 1.21567C15.3092 1.07333 14.941 1.00004 14.5691 1C14.1972 0.999958 13.829 1.07316 13.4854 1.21542C13.1419 1.35769 12.8297 1.56623 12.5667 1.82914L11.8989 2.49694C11.8989 2.49694 11.9826 3.91534 13.2336 5.16634C14.4846 6.41734 15.903 6.50105 15.903 6.50105L9.76773 12.6363C9.35193 13.0521 9.14493 13.2591 8.91543 13.4382C8.64483 13.6494 8.35413 13.8291 8.04333 13.9773C7.78143 14.1024 7.50242 14.1951 6.94532 14.3805L4.58192 15.1689M11.8989 2.49604L5.76363 8.63224C5.34783 9.04804 5.13993 9.25504 4.96173 9.48454C4.75063 9.75462 4.56984 10.0471 4.42262 10.3566C4.29752 10.6185 4.20483 10.8975 4.01853 11.4546L3.23103 13.818M3.23103 13.818L3.03933 14.3949C2.99439 14.5295 2.98782 14.6738 3.02036 14.8119C3.0529 14.9499 3.12325 15.0762 3.22354 15.1764C3.32382 15.2767 3.45006 15.3471 3.5881 15.3796C3.72614 15.4121 3.87051 15.4056 4.00503 15.3606L4.58192 15.1689M3.23103 13.818L4.58192 15.1689",
    stroke: "#1A4338",
    style: (_ref3 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.35
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCard);
export default __webpack_public_path__ + "static/media/editCard.6e23b663.svg";
export { ForwardRef as ReactComponent };